module.exports = __webpack_public_path__ + "static/img/logo-menu2_old.5c6f750e.png";